import { render, staticRenderFns } from "./SettingsPaymentPingpong.vue?vue&type=template&id=2c704764&lang=pug&"
import script from "./SettingsPaymentPingpong.vue?vue&type=script&lang=js&"
export * from "./SettingsPaymentPingpong.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPaymentPingpong.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c704764')) {
      api.createRecord('2c704764', component.options)
    } else {
      api.reload('2c704764', component.options)
    }
    module.hot.accept("./SettingsPaymentPingpong.vue?vue&type=template&id=2c704764&lang=pug&", function () {
      api.rerender('2c704764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/settings/SettingsPayment/SettingsPaymentPingpong.vue"
export default component.exports